import { Button } from 'antd';
import { Link } from 'react-router-dom';

import type {
  DublicateClientModel,
  GetColumnType,
} from '@pages/DublicateClients/types';

import type { ColumnsType } from 'antd/es/table';

export const getColumns: GetColumnType = ({
  openCombineClientsModal,
  statusesOptions,
}) => {
  const columns: ColumnsType<DublicateClientModel> = [
    {
      title: 'Клиент',
      dataIndex: 'Clients',
      key: 'Clients',
      render: (clients: DublicateClientModel['Clients']) => (
        <span className="no-wrap-text">
          {clients.map((client, index) => (
            <>
              <Link
                to={`/clients/edit/?id=${client.ClientId}&key=2`}
                key={client.ClientId}
              >
                {client.ClientName}
              </Link>
              {index < clients.length - 1 && ','}{' '}
            </>
          ))}
        </span>
      ),
    },
    {
      title: 'Пользователь',
      dataIndex: 'UserName',
      key: 'UserName',
      width: 140,
      render: (name: DublicateClientModel['UserName']) => {
        return <span className="no-wrap-text">{name}</span>;
      },
    },
    {
      title: 'Статус',
      dataIndex: 'StatusId',
      key: 'StatusId',
      render: (status: DublicateClientModel['StatusId']) => {
        return (
          <span className="no-wrap-text">
            {statusesOptions.find((s) => s.value === status)?.label || '-'}
          </span>
        );
      },
    },
    {
      title: null,
      key: 'actions',
      dataIndex: 'actions',
      width: 48,
      fixed: 'right',
      render: (_: unknown, row: DublicateClientModel) => (
        <Button onClick={() => openCombineClientsModal(row)}>Объединить</Button>
      ),
    },
  ];

  return columns;
};
